import { interactiveText } from "@indietabletop/appkit/common.css.ts";
import { Link } from "wouter";
import { hrefs } from "../../hrefs.ts";
import { pluralize } from "../fmt.ts";
import { section } from "./style.css.ts";

function HiddenItemsMessage(props: { count: number }) {
  if (props.count === 0) {
    return null;
  }

  const n_items = pluralize(props.count, { one: `# item `, other: `# items ` });

  const buy_now = (
    <span className={section.nonPrintable}>
      <Link href={hrefs.buy()} className={interactiveText}>
        Buy now
      </Link>
      .
    </span>
  );

  return (
    <p className={section.info}>
      Special rules for {n_items} are hidden because you do not have access to
      the Space Gits core rules. {buy_now}
    </p>
  );
}

type RuleItemProps = {
  id: string;
  name: string;
  description: string;
  cost?: number;
};

function RuleItem(props: RuleItemProps) {
  const { name, description } = props;

  return (
    <div className={section.item}>
      <div className={section.subheading}>{name}</div>
      <div className={section.itemDescription}>{description}</div>
    </div>
  );
}
export function RuleItemsSection(props: {
  hiddenItemsCount?: number;
  items: RuleItemProps[];
}) {
  const { items, hiddenItemsCount = 0 } = props;

  if (items.length + hiddenItemsCount === 0) {
    return null;
  }

  return (
    <div className={section.container}>
      <HiddenItemsMessage count={hiddenItemsCount} />

      <div className={section.items}>
        {items.map((item) => {
          // Cannot object spread, as class getters don't expand properly
          return (
            <RuleItem
              key={item.id}
              id={item.id}
              name={item.name}
              description={item.description}
              cost={item.cost}
            />
          );
        })}
      </div>
    </div>
  );
}
